var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ADA999"
    },
    d: "M400.144,392.073H129.153c-19.107,0-34.595-15.488-34.595-34.595V246.775h340.18v110.703 C434.739,376.585,419.251,392.073,400.144,392.073z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7E4CD"
    },
    d: "M367.284,458.717c-4.525-16.698-12.684-31.901-23.61-44.679c-6.044-7.068-12.925-13.396-20.494-18.83 c-18.919-13.584-42.113-21.586-67.18-21.586c-25.067,0-48.262,8.002-67.18,21.586c-7.568,5.435-14.45,11.762-20.494,18.83 c-10.926,12.777-19.085,27.98-23.61,44.678c0,0.001,0,0.001-0.001,0.002l0,0l32.904,8.408l9.191,35.739 c1.221,0.329,2.447,0.647,3.675,0.958l0,0c20.957,5.328,42.902,8.178,65.515,8.178c23.938,0,47.129-3.191,69.189-9.136l9.715-35.739 L367.284,458.717L367.284,458.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3E29A"
    },
    d: "M186.811,475.885l-17.297-18.226l-17.297,4.837v28.421c7.515,3.199,15.211,6.051,23.063,8.556 c3.365,1.074,6.76,2.081,10.181,3.024c0.45,0.123,0.899,0.244,1.35,0.366V475.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBD37A"
    },
    d: "M325.38,475.89c0,0-0.19,4.84-0.19,7.282v19.692c0.45-0.121,0.901-0.241,1.35-0.366 c3.423-0.942,6.816-1.949,10.181-3.024c7.852-2.506,15.548-5.358,23.063-8.556v-1.981v-26.44l-17.297-4.798L325.38,475.89z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE6054"
    },
    d: "M359.784,462.498c2.521-1.215,5.022-2.475,7.5-3.78c-4.525-16.698-12.684-31.902-23.611-44.68 c-3.198,5.534-6.018,11.314-8.438,17.297c-5.611,13.877-9.038,28.87-9.853,44.554c8.849-2.667,17.519-5.857,25.981-9.534 C354.195,465.125,357.002,463.839,359.784,462.498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE6054"
    },
    d: "M186.604,475.885c-1.166-22.446-7.664-43.482-18.276-61.847 c-10.926,12.778-19.085,27.981-23.611,44.68c2.478,1.305,4.979,2.565,7.5,3.78C163.31,467.845,174.798,472.326,186.604,475.885z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#5B5751",
      enableBackground: "new"
    },
    d: "M285.51,441.664c-3.838-0.063-7.555,0.409-11.083,1.349 c-12.091,3.22-24.762,3.22-36.852,0c-3.527-0.94-7.244-1.413-11.083-1.349c-21.836,0.36-39.68,19.345-39.68,41.185v0.323v19.692 c22.06,5.946,45.251,9.136,69.189,9.136c23.938,0,47.129-3.191,69.189-9.136v-19.692v-0.324 C325.19,461.009,307.346,442.024,285.51,441.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#AB5034",
      enableBackground: "new"
    },
    d: "M367.284,458.718L367.284,458.718L367.284,458.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#5B5751",
      enableBackground: "new"
    },
    d: "M343.673,414.038c-6.044-7.068-12.925-13.396-20.494-18.83 c-18.917-13.584-42.112-21.586-67.179-21.586c-25.067,0-48.262,8.002-67.18,21.586c15.857,19.539,40.055,32.036,67.18,32.036 c15.338,0,29.742-3.996,42.231-11c8.951-5.02,20.227-3.478,27.436,3.827c3.461,3.507,6.661,7.273,9.569,11.264 c7.535,10.336,13.094,22.195,16.136,35.015c2.828-1.229,5.632-2.513,8.411-3.853c2.521-1.215,5.022-2.475,7.5-3.78 C362.759,442.019,354.601,426.816,343.673,414.038z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBD37A"
    },
    d: "M434.739,194.884c-8.462,0-16.443,2.039-23.5,5.631C392.595,129.988,333.923,66.721,263.47,62.506 l-52.986,334.167c13.872,7.522,29.502,11.544,45.516,11.544c23.445,0,46.072-8.611,63.56-24.225 c26.302-23.486,64.161-60.597,84.214-95.574c8.644,6.438,19.359,10.25,30.966,10.25c28.659,0,51.892-23.233,51.892-51.892 S463.398,194.884,434.739,194.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3E29A"
    },
    d: "M263.47,62.505c-2.477-0.148-4.965-0.234-7.47-0.234c-73.75,0-135.946,65.232-155.246,138.24 c-7.056-3.591-15.035-5.627-23.493-5.627c-28.659,0-51.892,23.233-51.892,51.892s23.233,51.892,51.892,51.892 c11.606,0,22.322-3.812,30.966-10.25c20.052,34.977,57.911,72.088,84.214,95.574c5.543,4.949,11.605,9.189,18.042,12.68 c23.227-0.149,45.615-8.732,62.951-24.212c37.311-33.316,97.882-94.049,97.882-137.216 C371.316,164.872,326.285,90.663,263.47,62.505z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBD37A"
    },
    d: "M172.973,278.487h-11.532c-4.778,0-8.649-3.872-8.649-8.649c0-4.776,3.871-8.649,8.649-8.649h11.532 c4.778,0,8.649,3.872,8.649,8.649C181.622,274.615,177.751,278.487,172.973,278.487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBD37A"
    },
    d: "M350.559,278.487h-11.532c-4.777,0-8.649-3.872-8.649-8.649c0-4.776,3.871-8.649,8.649-8.649h11.532 c4.777,0,8.649,3.872,8.649,8.649C359.208,274.615,355.336,278.487,350.559,278.487z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E2C35A"
    },
    cx: 434.739,
    cy: 246.775,
    r: 17.297
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EBD37A"
    },
    cx: 77.262,
    cy: 246.775,
    r: 17.297
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBD37A"
    },
    d: "M385.774,197.89c-0.224,0.226-0.446,0.452-0.634,0.646c-19.135,19.665-45.561,30.943-72.501,30.943 h-4.746c-52.643,0-97.754-37.662-107.265-89.553c-1.611-8.8-9.671-14.913-18.578-14.108c-8.91,0.81-15.732,8.281-15.732,17.226 c0,38.009-18.132,63.608-33.342,78.39c-13.42,13.043-21.118,31.124-21.118,49.605v23.424c9.366,14.973,21.65,30.167,34.595,44.369 V271.04c0-9.191,3.876-18.229,10.634-24.796c9.36-9.097,22.349-24.295,31.753-45.503c26.051,38.597,70.077,63.332,119.054,63.332 h4.746c36.221,0,71.683-15.094,97.327-41.443l0.309-0.315L385.774,197.89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#474641"
    },
    cx: 198.343,
    cy: 246.775,
    r: 17.297
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#474641"
    },
    cx: 313.658,
    cy: 246.775,
    r: 17.297
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE6054"
    },
    d: "M268.685,290.019h-25.369c-4.778,0-8.649-3.872-8.649-8.649s3.871-8.649,8.649-8.649h25.369 c4.778,0,8.649,3.872,8.649,8.649S273.463,290.019,268.685,290.019z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ADA999"
    },
    d: "M182.31,206.092c-3.646,0-7.037-2.324-8.223-5.979c-1.476-4.542,1.01-9.421,5.552-10.897 c12.251-3.981,25.187-3.981,37.409-0.001c4.542,1.478,7.025,6.36,5.547,10.901c-1.477,4.542-6.357,7.027-10.901,5.547 c-8.724-2.84-17.959-2.838-26.71,0.005C184.097,205.955,183.196,206.092,182.31,206.092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ADA999"
    },
    d: "M434.728,157.85c-0.083-7.374-1.371-14.772-3.948-21.903c-3.501-9.685-8.254-18.921-14.23-27.439 c-4.784-6.819-10.118-13.213-15.938-19.116c-26.671-27.076-63.525-43.819-104.235-43.819c0-30.113-28.327-52.012-56.902-43.853 c-51.386,14.657-96.679,48.685-124.366,93.825c-8.97,14.624-15.303,30.617-18.973,47.248c-1.084,4.914-1.599,9.976-1.573,15.056 h-0.003v13.972v26.028v159.63h34.595v-86.439c0-14.045,5.803-27.412,15.875-37.201c16.076-15.624,38.585-45.573,38.585-90.795 c10.826,59.069,62.082,103.732,124.279,103.732h4.746c32.044,0,62.549-13.212,84.896-36.176c0.17-0.174,0.339-0.346,0.51-0.517 c9.392-9.391,22.365-15.2,36.695-15.2V157.85H434.728z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1BDAB"
    },
    d: "M242.302,1.014c-0.942,0.204-1.884,0.437-2.828,0.706c-33.908,9.671-65.164,27.778-90.458,51.947 l-0.01,0.018c-13.032,12.454-24.485,26.512-33.898,41.859c-8.97,14.624-15.303,30.617-18.973,47.248 c-0.386,1.75-0.675,3.523-0.918,5.306l0,0l0,0c-0.439,3.221-0.672,6.48-0.655,9.75h-0.003v13.972v11.575 c0,9.766,9.594,16.784,18.833,13.621c0.057-0.02,0.113-0.039,0.167-0.059c15.318-5.445,27.609-17.887,32.288-34.131 c1.899-6.594,3.171-13.394,3.171-19.783l0,0c0-31.212,12.399-61.146,34.469-83.216L242.302,1.014z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1BDAB"
    },
    d: "M401.216,90.009l-0.604-0.617c-26.671-27.076-63.525-43.819-104.235-43.819l-60.934,70.606 c-13.407,15.534-15.178,38.215-3.76,55.265c16.619,24.818,44.824,40.736,76.21,40.736h4.746c3.169,0,6.33-0.189,9.466-0.56 c23.753-2.813,44.883-16.444,58.037-36.42l8.567-13.01c1.434-2.178,2.538-4.5,3.35-6.895 C397.034,143.857,405.365,119.274,401.216,90.009z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.5fe81be470f4e5034366ba401d32e471.svg";
export { ForwardRef as ReactComponent };